import React, { useEffect, useRef } from 'react'
import style from '../styles/cabinet.module.scss'
import { GxIcon } from '@garpix/garpix-web-components-react'
import { NavLink } from 'react-router-dom'

interface IProps {
  pageId: number | string
  cabinetMenu: any[] | undefined
}

const CabinetNavigation = ({
  pageId,
  cabinetMenu
}: IProps): React.ReactElement => {
  const currentLinkRef = useRef<HTMLSpanElement>(null)

  useEffect(() => {
    const checkPage = setInterval(() => {
      if (document.readyState === 'complete') {
        currentLinkRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'nearest'
        })
        clearInterval(checkPage)
      }
    }, 100)
  }, [pageId])

  return (
    <>
      {cabinetMenu !== undefined
        ? (
          <nav className={style.cabinet_nav}>
            {cabinetMenu.map((el) => {
              return (
                <NavLink
                  key={el.id}
                  to={el.property_link_value}
                  className={({ isActive }) =>
                  `${style.cabinet_nav__link} ${
                    isActive ? style['cabinet_nav__link--active'] : ''
                  }`}
                >
                  {({ isActive }) => (
                    <span
                      ref={isActive ? currentLinkRef : undefined}
                      className={style.cabinet_nav__link_span}
                    >
                      <GxIcon
                        src={el.property_icon_value?.[0]}
                        className={style.cabinet_nav__link_icon}
                      />
                      {el.name}
                    </span>
                  )}
                </NavLink>
              )
            })}
          </nav>
          )
        : undefined}
    </>
  )
}

export default CabinetNavigation
